import axios from 'axios';

const QUESTIONS_TYPES = 'cms/questions-types';

export function getQuestionsTypes() {
  return axios.get(QUESTIONS_TYPES);
}
